import { PROXY_SYM } from "./consts";
import { isPlainObject, isProduction, hasWindow } from "@rpldy/shared";

var isProxy = function isProxy(obj) {
  return !isProduction() && !!obj && !!~Object.getOwnPropertySymbols(obj).indexOf(PROXY_SYM);
}; //check if object is File or react-native file object (it wont by instanceof File in react-native)


var isNativeFile = function isNativeFile(obj) {
  return hasWindow() && obj instanceof File || obj.name && obj.size && obj.uri;
};

var isProxiable = function isProxiable(obj) {
  return Array.isArray(obj) || isPlainObject(obj) && !isNativeFile(obj);
};

export { isProxy, isProxiable };